import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { Toaster } from "sonner";
import ErrorBoundary from "./components/ErrorBoundary";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { AuthProvider } from "./context/AuthContext";
import { OrganizationProvider } from "./context/OrganizationContext";
import { SidebarProvider } from "./context/SidebarContext";
import { SocketProvider } from "./context/SocketContext";
import VisitorIdentification from "./components/VisitorIdentification";
import App from "./App";
import { DhLinkProvider } from "@denhartog/ui";
import { PortalLink } from "./components/PortalLink";
import "./index.css";
import { isMcpConsentDocument } from "./utils/mcpPrivacy";

if (isMcpConsentDocument) {
  const referrer = document.createElement("meta");
  referrer.name = "referrer";
  referrer.content = "no-referrer";
  document.head.appendChild(referrer);
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <OrganizationProvider>
            <SocketProvider>
              <SidebarProvider>
                <VisitorIdentification />
                <DhLinkProvider component={PortalLink}>
                  <App />
                </DhLinkProvider>
                {/* Sonner injecteert zelf `[data-sonner-toaster]{font-family:…}`
                    aan het eind van <head>. Die directe declaratie wint van de
                    overerving vanaf `body`, dus toasts bleven op de systeemfont
                    staan. De inline `style` wordt door sonner op het
                    `<ol data-sonner-toaster>` gespreid en wint altijd; een
                    CSS-regel zou `!important` of hogere specificiteit vragen. */}
                <Toaster
                  position="top-right"
                  richColors
                  closeButton
                  style={{ fontFamily: "var(--font-body)" }}
                />
              </SidebarProvider>
            </SocketProvider>
          </OrganizationProvider>
        </AuthProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  </StrictMode>,
);
